<script lang="ts">
  import type { FulfillmentInformationType } from "@shared/types/Cart";
  import FulfillmentDateAndTimeSection from "@retailer/svelte/Cart/Page/OrderFulfillment/FulfillmentDateAndTimeSection.svelte";
  import FulfillmentPaymentMethodRadioGroup from "@retailer/svelte/Cart/Page/OrderFulfillment/FulfillmentPaymentMethodRadioGroup.svelte";

  export let fulfillmentInformation: FulfillmentInformationType;
  export let onDateSelect: (orderWarehouseId: number, selectedDate: Date) => void;
  export let onTimeSelect: (orderWarehouseId: number, selectedTime: string) => void;
  export let onPaymentMethodSelect: (orderId: number, paymentMethod: string) => void;
  export let OHLQOrderPaymentMethodsEnabled: boolean;
  export let distributorUsesWineCellar: boolean = false;

  const pickupTitle = (pickupOrderWarehouse, distributorName) => {
    if (OHLQOrderPaymentMethodsEnabled) return `Pickup at ${pickupOrderWarehouse.formatted_name}`;

    return `${distributorName}: ${pickupOrderWarehouse.address || pickupOrderWarehouse.name}`;
  };

  const showTimeSelect =
    OHLQOrderPaymentMethodsEnabled && fulfillmentInformation.show_fulfillment_times;

  $: orderWarehouses = fulfillmentInformation.order_warehouses;
  $: order = fulfillmentInformation.order;
  $: pickupOrderWarehouses = orderWarehouses?.filter(
    orderWarehouse => !!orderWarehouse.warehouse_id,
  );
  $: deliveryOrderWarehouse = orderWarehouses?.find(orderWarehouse => !orderWarehouse.warehouse_id);
  $: distributorName = fulfillmentInformation.distributor_name;
  $: showPaymentMethods =
    (deliveryOrderWarehouse || (pickupOrderWarehouses && pickupOrderWarehouses.length > 0)) &&
    OHLQOrderPaymentMethodsEnabled &&
    fulfillmentInformation.show_payment_methods;
</script>

<div class:fizz-flow-16={!OHLQOrderPaymentMethodsEnabled}>
  {#if deliveryOrderWarehouse}
    <div
      class:fizz-label={!OHLQOrderPaymentMethodsEnabled}
      class:fizz-text-large={OHLQOrderPaymentMethodsEnabled}
      class:fizz-text-strong={OHLQOrderPaymentMethodsEnabled}
      class:fizz-stack-8={OHLQOrderPaymentMethodsEnabled}>{distributorName} Delivery</div
    >
    <div class:fizz-flex-row-8={showTimeSelect}>
      <FulfillmentDateAndTimeSection
        dates={fulfillmentInformation.delivery_fulfillment_dates}
        timeSlots={fulfillmentInformation.delivery_fulfillment_times}
        {onDateSelect}
        {onTimeSelect}
        orderWarehouseId={deliveryOrderWarehouse.id}
        {OHLQOrderPaymentMethodsEnabled}
        {showTimeSelect}
        {distributorUsesWineCellar}
      />
    </div>
  {/if}
  {#if pickupOrderWarehouses && pickupOrderWarehouses.length > 0}
    {#if !OHLQOrderPaymentMethodsEnabled}
      <div class="fizz-label">In store pickup</div>
    {/if}
    {#each pickupOrderWarehouses as pickupOrderWarehouse}
      <div
        class:fizz-label={!OHLQOrderPaymentMethodsEnabled}
        class:fizz-text-large={OHLQOrderPaymentMethodsEnabled}
        class:fizz-text-strong={OHLQOrderPaymentMethodsEnabled}
        class:fizz-stack-8={OHLQOrderPaymentMethodsEnabled}
      >
        {pickupTitle(pickupOrderWarehouse, distributorName)}
      </div>
      <div class:fizz-flex-row-8={showTimeSelect}>
        <FulfillmentDateAndTimeSection
          dates={fulfillmentInformation.pickup_fulfillment_dates}
          timeSlots={fulfillmentInformation.pickup_fulfillment_times}
          {onDateSelect}
          {onTimeSelect}
          orderWarehouseId={pickupOrderWarehouse.id}
          {OHLQOrderPaymentMethodsEnabled}
          {showTimeSelect}
          {distributorUsesWineCellar}
        />
      </div>
    {/each}
  {/if}
  {#if showPaymentMethods}
    <FulfillmentPaymentMethodRadioGroup
      orderId={order.id}
      availablePaymentMethods={fulfillmentInformation.available_payment_methods}
      {onPaymentMethodSelect}
    />
  {/if}
</div>
